<template>
	<div class="flex flex-col gap-2">
		<div class="flex items-center gap-2">
			<div class="px-2 py-1 overflow-x-auto border rounded">
				<span class="text-ellipsis whitespace-nowrap">{{ dynamicLink }}</span>
			</div>
			<AppButton
				variant="primary"
				class="self-start"
				:disabled="linkCopied"
				:icon="linkCopied ? 'check' : 'link'"
				@click="copyLink(dynamicLink)"
			>
				{{ linkCopied ? "Link gekopieerd" : "Kopieer link" }}
			</AppButton>
		</div>
		<hr class="w-full" />
		<div class="flex flex-col gap-2">
			<span class="text-sm text-gray-500">
				of laat de klant de qr-code scannen om meteen gegevens aan te leveren:
			</span>
			<!-- eslint-disable vue/no-v-html -->
			<div
				class="inline-block w-64 h-64"
				role="img"
				aria-label="QR-code voor het dataverzoek"
				v-html="renderSVG(dynamicLink)"
			/>
			<!-- eslint-enable -->
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { renderSVG } from "uqr";

defineProps<{
	dynamicLink: string;
}>();

const linkCopied = ref(false);
async function copyLink(link: string) {
	await navigator.clipboard.writeText(link);
	linkCopied.value = true;

	setTimeout(() => {
		linkCopied.value = false;
	}, 5_000);
}
</script>
